module.exports = __webpack_public_path__ + "img/7-m.78bbfa75.jpg";